var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.1055L15.2201 14.3788C17.9486 14.1514 18.5611 13.5555 18.8635 10.8343L19.5 5.10547",
    stroke: "#141B34",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.10547L6 5.10547M20.5 5.10547H17.5",
    stroke: "#141B34",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.10547C9 6.10547 10 6.10547 11 8.10547C11 8.10547 14.1765 3.10547 17 2.10547",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 19.1055,
    r: 2,
    stroke: "#141B34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 19.1055,
    r: 2,
    stroke: "#141B34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.1055L13.5 19.1055",
    stroke: "#141B34",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.10547H1.466C2.41068 1.10547 3.23414 1.73006 3.46326 2.6204L6.43852 14.182C6.58887 14.7662 6.4602 15.3852 6.08824 15.867L5.13213 17.1055",
    stroke: "#141B34",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart1);
export default __webpack_public_path__ + "static/media/cart1.a2c702f2963d62eba1fb341d013e3ff9.svg";
export { ForwardRef as ReactComponent };